import { CSSProperties } from "react";

export const XCombatPointSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      style={style}
      width={width}
      height={(width / 43) * 55}
      viewBox="0 0 43 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_219_411)">
        <path
          d="M39.5 31L21.5 13.5L4.5 31L22.5 48.5L39.5 31Z"
          fill="url(#paint0_radial_219_411)"
        />
      </g>
      <path d="M39.5 31L21.5 13.5L4.5 31L22.5 48.5L39.5 31Z" stroke="#80131F" />
      <g filter="url(#filter1_i_219_411)">
        <path
          d="M10 38.5C7.33333 42.3333 1.8 50.1 1 50.5L2 52.5L7 53.5L14 42.5L17 41.5L42 15V12.5L37 1L11 34.5L10 38.5Z"
          fill="#DC030D"
        />
      </g>
      <path
        d="M10 38.5C7.33333 42.3333 1.8 50.1 1 50.5L2 52.5L7 53.5L14 42.5L17 41.5L42 15V12.5L37 1L11 34.5L10 38.5Z"
        stroke="#401616"
        strokeOpacity="0.72"
      />
      <defs>
        <filter
          id="filter0_i_219_411"
          x="3.79309"
          y="12.7928"
          width="36.4138"
          height="36.4144"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.811765 0 0 0 0 0.027451 0 0 0 0 0.0392157 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_219_411"
          />
        </filter>
        <filter
          id="filter1_i_219_411"
          x="0.329163"
          y="0.0270691"
          width="42.1708"
          height="54.0304"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_219_411"
          />
        </filter>
        <radialGradient
          id="paint0_radial_219_411"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22 31) rotate(90) scale(11)"
        >
          <stop stopColor="#1F0702" />
          <stop offset="1" stopColor="#460205" />
        </radialGradient>
      </defs>
    </svg>
  );
};
